import { call, put } from 'redux-saga/effects';
import { ACTIONS, API_URL, APIS } from '../../_config';
import { CallApi, responseHandler } from '../api/callApi';
import { UpdateWithVariables } from '../../_common/functions';


export function* updateProfile(action: any): any {
    try {
        const data = action.payload;
        let API = UpdateWithVariables(APIS.PROFILE.UPDATE, data.urlParams)
        if (data.urlParams) {
            delete data.urlParams
        }
        const resp = yield call(CallApi.PUT, API, data, true);
        let respChecker = responseHandler(resp)
        if (respChecker.status) {
            console.log("resp=saga==>", resp);
            action && action.callbackSuccess && action.callbackSuccess(respChecker.data)
        } else {
            action && action.callbackError && action.callbackError(respChecker.data)
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
} 